import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const TimeOut = () => {
  const stepsToTimeOutPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Steps to an Effective Time-Out',
  );
  const timeOutQuestionsPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Common Parent Questions About Time-Out',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={[stepsToTimeOutPdf, timeOutQuestionsPdf]}
        vidSrc={1194425993}
      />
    </div>
  );
};

export default TimeOut;
